import sharedStyles from "@whatslly/ui-components/v2/Tables/Table/Table.module.scss";
import { Button } from "@whatslly/ui-components/v2/Button";
import { Select } from "@whatslly/ui-components/v2/BaseElements/Select";
import React from "react";
import { useTranslation } from "react-i18next";

export type MultipleItemsActionOptions<T> = {
  name: string;
  selectedItems: T[];
  onToggleRow: (item: T) => void;
  onDeselectAllItems: () => void;
  actions: {
    label: string;
    onClick: () => void | Promise<void>;
    __disabled__?: boolean;
  }[];
};

export const MultipleItemsAction = <T,>({ selectedItemsOptions }: { selectedItemsOptions: MultipleItemsActionOptions<T> }) => {
  const { t } = useTranslation();
  return (
    <div className={sharedStyles.multipleItemsActionBar}>
      <div className={sharedStyles.multipleItemsActionBarLeft}>
        <div data-testid="bulk-actions-selected-count">
          {`${selectedItemsOptions.selectedItems.length} ${selectedItemsOptions.name} `}
          {t("table_multiple_items_action.selected")}
        </div>
        <Button onClick={selectedItemsOptions.onDeselectAllItems} paddingInline={"small"} data-testid="bulk-actions-deselect-all">
          {t("table_multiple_items_action.deselect_all")}
        </Button>
      </div>
      <div>
        <Select
          className={sharedStyles.multipleItemsActionSelect}
          controlClassName={sharedStyles.multipleItemsActionSelect}
          menuWidth={"220px"}
          selectSize={"small"}
          borderColor={"none"}
          backgroundColor={"none"}
          placeholder={<span className={sharedStyles.selectActionPlaceholder}>{t("table_multiple_items_action.actions_available")}</span>}
          value={null}
          options={selectedItemsOptions.actions}
          data-testid="bulk-actions-select"
          onChange={async (newValue: { label: string; onClick: () => void | Promise<void>; __disabled__?: boolean }) => {
            await newValue.onClick();
            selectedItemsOptions.onDeselectAllItems();
          }}
        />
      </div>
    </div>
  );
};
